<template>
  <v-dialog
    v-model="confirm"
    @click:outside="$emit('close')"
    width="500"
  >
    <v-card class="p-2">
      <v-card-title class="d-flex justify-content-center">
        <h2 class="m-0 p-0">{{title}}</h2>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mt-4 mb-4">
        <h5>{{text}}</h5>
        <br>
        <template>
          <slot name="subText"></slot>
        </template>
      </v-card-text>
      <v-card-actions>
        <div class="col-md-12 d-flex justify-content-end">
          <v-btn outlined class="btn-back mr-2" @click="$emit('close')">Voltar</v-btn>
          <v-btn class="success" @click="$emit('close'); $emit('save')">Confirmar</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name:"ModalConfirmation",
  props:{
    confirm:Boolean,
    title:String,
    text:String
  },
  mounted() {
    if(this.confirm === true) {
      document.addEventListener("keypress", (e) => {
        if(e.key === "Enter") {
          this.$emit("save");
        }
      })
    }
  }
}
</script>